import {
  default as logoDark,
  default as logoLight,
  default as logoSm,
} from 'assets/images/logo.png';
import userProfile from 'assets/images/users/user-profile.png';
import { Dropdown } from 'Common/Components/Dropdown';
import LanguageDropdown from 'Common/LanguageDropdown';
import SearchProduct from 'Common/SearchProduct';
import { LogOut, Menu, ShoppingCart, User2 } from 'lucide-react';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import { appDispatch } from 'slices';
import { ProfileHook } from 'slices/auth/login/hook';
import { EcommerceHook } from 'slices/ecommerce/hook';
import { updateProvider, updateSearch } from 'slices/ecommerce/reducer';
import { changeLeftsidebarSizeType } from 'slices/layouts/thunk';
import { ShoppingCartHook } from 'slices/shoppingCart/hook';

const Header = ({ handleDrawer }: any) => {
  const dispatch = appDispatch();
  const navigate = useNavigate();

  const { user } = ProfileHook();
  const { search } = EcommerceHook();
  const { carts } = ShoppingCartHook();

  const token = localStorage.getItem('auth');

  const [selectedCategory, setSelectedCategory] = useState('TAOBAO');

  const selectLayoutState = (state: any) => state.Layout;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (layout: any) => ({
      layoutType: layout.layoutType,
    })
  );

  const { layoutType } = useSelector(selectLayoutProperties);

  const filterSearchData = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateSearch(e.target.value));
  };

  const handleChangeProvider = (value: string) => {
    setSelectedCategory(value);
    dispatch(updateProvider(value));
  };

  const handleSearchClick = () => {
    if (search) {
      navigate(`/search?keyword=${search}`);
    }
  };

  const counts = useMemo(() => {
    return carts.reduce((pre, cur) => {
      return pre + cur.quantity;
    }, 0);
  }, [carts]);

  useEffect(() => {
    // resize
    const handleResizeLayout = () => {
      var windowSize = document.documentElement.clientWidth;

      if (windowSize < 768) {
        dispatch(changeLeftsidebarSizeType('lg'));
      } else if (windowSize <= 1024) {
        if (layoutType === 'vertical') {
          dispatch(changeLeftsidebarSizeType('sm'));
        } else {
          dispatch(changeLeftsidebarSizeType('lg'));
        }
      } else {
        dispatch(changeLeftsidebarSizeType('lg'));

        // dispatch(changeLeftsidebarSizeType(layoutSidebarSizeType === "sm" ? "lg" : "sm"));
      }
    };

    // out side click
    const outerSideElement = () => {
      var windowSize = document.documentElement.clientWidth;
      var sidebarOverlay = document.getElementById('sidebar-overlay') as any;
      if (sidebarOverlay) {
        sidebarOverlay.addEventListener('click', () => {
          if (!sidebarOverlay.classList.contains('hidden')) {
            if (windowSize <= 768) {
              document?.querySelector('.app-menu')?.classList.add('hidden');
              document.body.classList.remove('overflow-hidden');
              sidebarOverlay.classList.add('hidden');
            } else {
              dispatch(changeLeftsidebarSizeType('lg'));
            }
          }
        });
      }
    };

    // scroll
    const scrollNavigation = () => {
      // var scrollUp = document.documentElement.scrollTop;
      // if (scrollUp >= 50) {
      //   document.getElementById('page-topbar')?.classList.add('is-sticky');
      // } else {
      //   document.getElementById('page-topbar')?.classList.remove('is-sticky');
      // }
    };

    window.addEventListener('scroll', scrollNavigation, true);
    window.addEventListener('click', outerSideElement);
    window.addEventListener('resize', handleResizeLayout);

    // Cleanup function to remove the event listeners
    return () => {
      window.removeEventListener('scroll', scrollNavigation, true);
      window.removeEventListener('click', outerSideElement);
      window.removeEventListener('resize', handleResizeLayout);
    };
  }, [layoutType, dispatch]);

  return (
    <React.Fragment>
      <header
        id="page-topbar"
        className="position-sticky top-0 z-50 w-full"
      >
        <div className="layout-width">
          <div className="flex items-center flex-col sm:flex-row px-2 mx-auto bg-common group-data-[topbar=dark]:bg-topbar-dark group-data-[topbar=dark]:border-topbar-dark group-data-[topbar=brand]:bg-topbar-brand group-data-[topbar=brand]:border-topbar-brand shadow-md h-header shadow-slate-200/50 group-data-[navbar=bordered]:rounded-md group-data-[topbar=dark]:dark:bg-zink-700 group-data-[topbar=dark]:dark:border-zink-700 dark:shadow-none group-data-[navbar=bordered]:shadow-none group-data-[layout=horizontal]:group-data-[navbar=bordered]:rounded-b-none group-data-[layout=horizontal]:shadow-none">
            <div className="h-header-standard flex items-center w-full group-data-[layout=horizontal]:mx-auto group-data-[layout=horizontal]:max-w-screen-2xl navbar-header group-data-[layout=horizontal]:ltr:xl:pr-3 group-data-[layout=horizontal]:rtl:xl:pl-3">
              <div className="items-center justify-center hidden px-5 text-center h-header group-data-[layout=horizontal]:md:flex group-data-[layout=horizontal]:ltr::pl-0 group-data-[layout=horizontal]:rtl:pr-0">
                <Link to="/">
                  <span className="hidden">
                    <img src={logoSm} alt="" className="h-6 mx-auto" loading="lazy" />
                  </span>
                  <span className="group-data-[topbar=dark]:hidden group-data-[topbar=brand]:hidden">
                    <img src={logoDark} alt="" className="h-10 mx-auto" loading="lazy" />
                  </span>
                </Link>
                <Link
                  to="/"
                  className="hidden group-data-[topbar=dark]:block group-data-[topbar=brand]:block"
                >
                  <span className="group-data-[topbar=dark]:hidden group-data-[topbar=brand]:hidden">
                    <img src={logoSm} alt="" className="h-6 mx-auto" loading="lazy" />
                  </span>
                  <span className="group-data-[topbar=dark]:block group-data-[topbar=brand]:block">
                    <img src={logoLight} alt="" className="h-6 mx-auto" loading="lazy" />
                  </span>
                </Link>
              </div>

              {/* <button
                onClick={handleTopbarHamburgerIcon}
                type="button"
                className="inline-flex relative justify-center items-center p-0 text-topbar-item transition-all size-[37.5px] duration-75 ease-linear bg-topbar rounded-md btn hover:bg-slate-100 group-data-[topbar=dark]:bg-topbar-dark group-data-[topbar=dark]:border-topbar-dark group-data-[topbar=dark]:text-topbar-item-dark group-data-[topbar=dark]:hover:bg-topbar-item-bg-hover-dark group-data-[topbar=dark]:hover:text-topbar-item-hover-dark group-data-[topbar=brand]:bg-topbar-brand group-data-[topbar=brand]:border-topbar-brand group-data-[topbar=brand]:text-topbar-item-brand group-data-[topbar=brand]:hover:bg-topbar-item-bg-hover-brand group-data-[topbar=brand]:hover:text-topbar-item-hover-brand group-data-[topbar=dark]:dark:bg-zink-700 group-data-[topbar=dark]:dark:text-zink-200 group-data-[topbar=dark]:dark:border-zink-700 group-data-[topbar=dark]:dark:hover:bg-zink-600 group-data-[topbar=dark]:dark:hover:text-zink-50 group-data-[layout=horizontal]:flex group-data-[layout=horizontal]:md:hidden hamburger-icon"
                id="topnav-hamburger-icon"
              >
                <Menu className="w-5 h-5 group-data-[sidebar-size=sm]:block" />
                <ChevronsLeft className="w-5 h-5 group-data-[sidebar-size=sm]:hidden" />
                <ChevronsRight className="hidden w-5 h-5 group-data-[sidebar-size=sm]:block" />
              </button> */}

              <div className="h-[100%] flex gap-2 sm:ml-auto items-center sm:w-full flex-grow sm:grow-0">
                <SearchProduct
                  selectedCategory={selectedCategory}
                  filterSearchData={filterSearchData}
                  setSelectedCategory={handleChangeProvider}
                  handleSearchClick={handleSearchClick}
                />
                {/* <ExchangeRate /> */}
                {/* LanguageDropdown */}
                <LanguageDropdown />

                {/* LightDark */}
                {/* <LightDark /> */}

                {/* AddToCartDrawer */}
                <div className="relative flex items-center h-header">
                  <button
                    type="button"
                    data-drawer-target="cartSidePenal"
                    className="inline-flex relative justify-center items-center p-0 border border-white text-topbar-item transition-all size-[37.5px] duration-200 ease-linear rounded-md btn"
                    onClick={handleDrawer}
                  >
                    <ShoppingCart className="inline-block size-5 stroke-2 stroke-white"></ShoppingCart>
                    <span className="absolute flex items-center justify-center size-5 text-xs text-common bg-white border-white rounded-full -top-2 -right-2">
                      {counts}
                    </span>
                  </button>
                </div>

                {/* NotificationDropdown */}
                {/* <NotificationDropdown /> */}

                {/* <div className="relative items-center hidden h-header md:flex">
                  <button
                    onClick={handleToggleDrawer}
                    data-drawer-target="customizerButton"
                    type="button"
                    className="inline-flex justify-center items-center p-0 text-topbar-item transition-all size-[37.5px] duration-200 ease-linear bg-topbar group-data-[topbar=dark]:text-topbar-item-dark rounded-md btn hover:bg-topbar-item-bg-hover hover:text-topbar-item-hover group-data-[topbar=dark]:bg-topbar-dark group-data-[topbar=dark]:hover:bg-topbar-item-bg-hover-dark group-data-[topbar=dark]:hover:text-topbar-item-hover-dark group-data-[topbar=brand]:bg-topbar-brand group-data-[topbar=brand]:hover:bg-topbar-item-bg-hover-brand group-data-[topbar=brand]:hover:text-topbar-item-hover-brand group-data-[topbar=dark]:dark:bg-zink-700 group-data-[topbar=dark]:dark:hover:bg-zink-600 group-data-[topbar=brand]:text-topbar-item-brand group-data-[topbar=dark]:dark:hover:text-zink-50 group-data-[topbar=dark]:dark:text-zink-200"
                  >
                    <Settings className="inline-block size-5 stroke-1 fill-slate-100 group-data-[topbar=dark]:fill-topbar-item-bg-hover-dark group-data-[topbar=brand]:fill-topbar-item-bg-hover-brand"></Settings>
                  </button>
                </div> */}

                {token ? (
                  <Dropdown className="relative hidden sm:flex items-center h-header">
                    <Dropdown.Trigger
                      type="button"
                      className="inline-block p-0 transition-all duration-200 ease-linear bg-topbar rounded-full text-topbar-item dropdown-toggle btn"
                      id="dropdownMenuButton"
                      data-bs-toggle="dropdown"
                    >
                      <div className="bg-common rounded-full">
                        <img
                          src={userProfile}
                          alt=""
                          className="size-[37.5px] rounded-full"
                        />
                      </div>
                    </Dropdown.Trigger>
                    <Dropdown.Content
                      placement="right-end"
                      className="absolute z-50 p-4 ltr:text-left rtl:text-right bg-white rounded-md shadow-md !top-4 dropdown-menu min-w-[14rem] dark:bg-zink-600"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <div className="flex gap-3 mb-3">
                        <div className="relative inline-block shrink-0">
                          <div className="rounded bg-slate-100 dark:bg-zink-500">
                            <img
                              src={userProfile}
                              alt=""
                              className="size-12 rounded"
                            />
                          </div>
                          <span className="-top-1 ltr:-right-1 rtl:-left-1 absolute size-2.5 bg-green-400 border-2 border-white rounded-full dark:border-zink-600"></span>
                        </div>
                        <div>
                          <h6 className="mb-1 text-15">
                            {user?.firstName || 'admin'}
                            {/* username */}
                          </h6>
                          {/* <p className="text-slate-500 dark:text-zink-300">
                            CEO & Founder
                          </p> */}
                        </div>
                      </div>
                      <ul>
                        <li>
                          <a
                            className="block ltr:pr-4 rtl:pl-4 py-1.5 text-base font-medium transition-all duration-200 ease-linear text-slate-600 dropdown-item hover:text-custom-500 focus:text-custom-500 dark:text-zink-200 dark:hover:text-custom-500 dark:focus:text-custom-500"
                            href={process.env.PUBLIC_URL + '/purchase-request'}
                          >
                            <Menu className="inline-block size-4 ltr:mr-2 rtl:ml-2"></Menu>{' '}
                            Purchase
                          </a>
                        </li>
                        <li>
                          <a
                            className="block ltr:pr-4 rtl:pl-4 py-1.5 text-base font-medium transition-all duration-200 ease-linear text-slate-600 dropdown-item hover:text-custom-500 focus:text-custom-500 dark:text-zink-200 dark:hover:text-custom-500 dark:focus:text-custom-500"
                            href={process.env.PUBLIC_URL + '/user-profile'}
                          >
                            <User2 className="inline-block size-4 ltr:mr-2 rtl:ml-2"></User2>{' '}
                            Profile
                          </a>
                        </li>
                        <li className="pt-2 mt-2 border-t border-slate-200 dark:border-zink-500">
                          <a
                            className="block ltr:pr-4 rtl:pl-4 py-1.5 text-base font-medium transition-all duration-200 ease-linear text-slate-600 dropdown-item hover:text-custom-500 focus:text-custom-500 dark:text-zink-200 dark:hover:text-custom-500 dark:focus:text-custom-500"
                            href={process.env.PUBLIC_URL + '/logout'}
                          >
                            <LogOut className="inline-block size-4 ltr:mr-2 rtl:ml-2"></LogOut>{' '}
                            Sign Out
                          </a>
                        </li>
                      </ul>
                    </Dropdown.Content>
                  </Dropdown>
                ) : (
                  <Link to="/login" className="text-white">
                    Login
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;
